import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';
import { connect, useSelector } from 'react-redux';
import { compose } from 'recompose';

import MfaDialog from '../../MfaDialog';
import ActionConfirmation from '../../common/ActionConfirmation';
import Button from '../../Button';
import { actions as enableMfaActions } from '../../../redux/profiles/mfa-enable';
import { actions as disableMfaActions } from '../../../redux/profiles/mfa-disable';
import { actions as mfaConfirmationsActions } from '../../../redux/profiles/mfa-confirmations';
import {
  getMfaConfirmationData,
  getEnableMfa,
} from '../../../redux/profiles/selectors';
import styles from '../index.styl';

const MfaSettings = ({
  id,
  intl,
  active,
  resetMfa,
  enableMfa,
  disableMfa,
  credential,
  sendMfaConfirmation,
  clearMfaConfirmation,
}) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showMfaDialog, setShowMfaDialog] = useState(false);
  const { formatMessage } = intl;
  const {
    data: mfaConfirmationData,
    sending: mfaConfirmationLoading,
  } = useSelector(getMfaConfirmationData);
  const { error, data: enableMfaData, sending: enableMfaLoading } = useSelector(
    getEnableMfa,
  );

  useEffect(() => {
    if (mfaConfirmationData) {
      setShowMfaDialog(true);
    }
  }, [mfaConfirmationData]);

  useEffect(() => {
    if (enableMfaData) {
      handleCloseMfaModal();
    }
  }, [enableMfaData]);

  const handleActivateMfa = () => {
    sendMfaConfirmation({ login: credential });
  };

  const handleInActivateMfa = () => {
    disableMfa({ id });
  };

  const handleSendMfaCode = code => {
    enableMfa({ otp_confirmation: code, id });
  };

  const handleCloseMfaModal = () => {
    setShowMfaDialog(false);
    clearMfaConfirmation();
    resetMfa();
  };

  return (
    <section styleName="privacy-settings">
      <h3 styleName="sectionTitle">
        {formatMessage({ id: 'profile.section.mfaSettings' })}
      </h3>
      <div className="label" styleName="mfaField">
        {formatMessage({
          id: active
            ? 'profile.section.mfaSettings.label.active'
            : 'profile.section.mfaSettings.label.inActive',
        })}
        <span styleName="gray-text">
          {` (${formatMessage({
            id: 'profile.section.mfaSettings.label.helperText',
          })})`}
        </span>
      </div>
      <div className="action">
        {active ? (
          <Button
            color="accent"
            type="button"
            disabled={mfaConfirmationLoading}
            onClick={() => setShowConfirmDialog(true)}
          >
            {formatMessage({
              id: 'profile.section.mfaSettings.button.inActivate',
            })}
          </Button>
        ) : (
          <Button
            color="accent"
            type="button"
            disabled={mfaConfirmationLoading}
            onClick={handleActivateMfa}
          >
            {formatMessage({
              id: 'profile.section.mfaSettings.button.activate',
            })}
          </Button>
        )}
      </div>

      {showMfaDialog && (
        <MfaDialog
          open={showMfaDialog}
          onClose={handleCloseMfaModal}
          onSubmit={handleSendMfaCode}
          mfaData={mfaConfirmationData}
          error={error}
          loading={enableMfaLoading}
        />
      )}

      {showConfirmDialog && (
        <ActionConfirmation
          intl={intl}
          onSubmit={handleInActivateMfa}
          onClose={() => setShowConfirmDialog(false)}
          opened={showConfirmDialog}
          withHeading={false}
          actionButtonText={formatMessage({
            id: 'profile.section.mfaSettings.confirmModal.inActivate.button',
          })}
          content={
            <h1 styleName="dialogTitle">
              {formatMessage({
                id: 'profile.section.mfaSettings.confirmModal.inActivate.title',
              })}
            </h1>
          }
        />
      )}
    </section>
  );
};

MfaSettings.propTypes = {
  active: PropTypes.bool,
  credential: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  id: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
  enableMfa: PropTypes.func.isRequired,
  disableMfa: PropTypes.func.isRequired,
  resetMfa: PropTypes.func.isRequired,
  sendMfaConfirmation: PropTypes.func.isRequired,
  clearMfaConfirmation: PropTypes.func.isRequired,
};

export default compose(
  injectIntl,
  connect(
    null,
    {
      enableMfa: enableMfaActions.send,
      resetMfa: enableMfaActions.clear,
      disableMfa: disableMfaActions.send,
      sendMfaConfirmation: mfaConfirmationsActions.send,
      clearMfaConfirmation: mfaConfirmationsActions.clear,
    },
  ),
  CSSModules(styles, { allowMultiple: true }),
)(MfaSettings);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/MfaSettings/index.jsx